import utils from './utils';

export default {
  searchPath(query) {
    return utils.buildURL('/search/topics', {
      q: query
    });
  },

  keywordSearchPath(query, sort = null) {
    return utils.buildURL('/search/topics', { q: query, sort });
  }
};
